<div class="mobileContainer">
    <div class="screenContainer">
        <ng-content></ng-content>
    </div>
</div>